import { useState, type FormEvent } from "react";
import { Button, TextField } from "@plataforma/design-system";
import { useAuth } from "../../app/auth";
import { useAppConfig } from "../../app/config";
import { HelpButton } from "../../app/help";
import { errorMessage } from "../../lib/api";
import "./login.css";

export function LoginPage() {
  const { config } = useAppConfig();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login({ email, password });
    } catch (failure) {
      setError(errorMessage(failure));
      setPassword("");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login">
      <section className="login__card" aria-labelledby="login-title">
        <div className="ds-brand" style={{ padding: "0 0 24px" }}>
          {config.branding.logoUrl ? <img className="ds-brand__mark" src={config.branding.logoUrl} alt="" /> : <div className="ds-brand__mark" aria-hidden="true">{config.branding.monogram}</div>}
          <div>
            <div className="ds-brand__name">{config.name}</div>
            {config.branding.tagline ? <div className="ds-brand__tagline">{config.branding.tagline}</div> : null}
          </div>
        </div>
        <h1 id="login-title" className="ds-h2" style={{ marginBottom: 4 }}>Entrar</h1>
        <p className="ds-muted ds-small" style={{ marginBottom: 18 }}>Acesso restrito à equipe.</p>
        <form onSubmit={submit}>
          <TextField label="E-mail" type="email" autoComplete="username" required value={email} onChange={(event) => setEmail(event.target.value)} />
          <TextField label="Senha" type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} error={error} />
          <Button type="submit" variant="primary" block disabled={submitting}>{submitting ? "Entrando…" : "Entrar"}</Button>
        </form>
        <div style={{ marginTop: 14, textAlign: "center" }}><HelpButton topic="login" variant="quiet" /></div>
      </section>
    </main>
  );
}
